module.exports = __webpack_public_path__ + "static/media/ios-thermometer.ab9af4d0.svg";